import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import { AxLimeStone } from "../../Limestone/AxLimeStone";
import { ProgressBar, ProgressBarMode } from "../Global/Progressbar";
import Swal from "sweetalert2";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";

@ModuleName("AxProdSummary")
export class AxProdSummary implements AxInit {
    private InitData: AxSummaryInitData;

    constructor(private _Progressbar = new ProgressBar(),
        private _AxLimestone = new AxLimeStone(),
        private _I18nHelper = new I18nHelper()
    ) { }

    AxInit(init: AxSummaryInitData): void {
        this.InitData = init;

        let progress: number = init.ProgressBarMode == ProgressBarMode.Suballotment ? 2 : 1;

        this._Progressbar.Init({
            Mode: init.ProgressBarMode,
            Progress: progress
        });
        $('.product_selection__image').lazyload();

        $('.tv4_prod-selection__addToCart-submit').click(e => {
            this._AxLimestone.LockButton(e.delegateTarget);
            this.CheckSelectedDate();
        });

        $('.tv4_side__selection-timing--toggle').click(e => {
            this.ToggleTimings(e.delegateTarget);
        });
    }

    ToggleTimings(delegatedTarget: HTMLElement) {
        let $e = $(delegatedTarget);
        $e.next().slideToggle('fast');
        $e.find('i').toggleClass('las la-angle-down').toggleClass('las la-angle-up');
    }

    CheckSelectedDate() {
        const currentDate = new Date();
        const momentInstance = moment(currentDate);
        if (this.InitData.PostData.Date < momentInstance.format('YYYY-MM-DD')) {
            Swal.fire({
                title: this._I18nHelper.GetTranslation(Translations.WrongDay),
                text: this._I18nHelper.GetTranslation(Translations.WrongSelectedDay),
                icon: 'warning',
                showCancelButton: false,
                confirmButtonText: this._I18nHelper.GetTranslation(Translations.AdminClose)
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload();
                }
            });
        }
        else {
            this.AddToCart("Tickets");
        }
    }

    AddToCart(continueShoppingPath: string) {
        AxessViewer.loadPartialView(this.InitData.PostURL, this.InitData.PostData, (result) => {

            AxLoad.LoadModule('AxFireShoppingCartModal', {
                result: result,
                continueShoppingPath: continueShoppingPath,
                btn: '.tv4_prod-selection__addToCart-submit',
                ResetQuantity: false,
                queryAddition: this.InitData.ProgressBarMode == ProgressBarMode.Suballotment ? '?ref=pit' : '?ref=pi'
            });
        }, {
            silent: true,
            skipShoppingCartReload: false,
            addCulturInfo: false
        });
    }
}


interface AxSummaryInitData {
    ProgressBarMode: ProgressBarMode;
    PostData: any;
    PostURL: string;
}